import {
  FormDefinitionType,
  FormExecutionType,
  TaskExecutionComponentProps,
  TaskExecutionState,
  TaskForm,
  TaskFormExecution,
} from "../../../types";
import LinearFormExecutionComponent from "./LinearFormExecutionComponent";
import WizardFormExecutionComponent from "./WizardFormExecutionComponent";

export enum FormExecutionViewSize {
  SMALL = 0.25,
  MEDIUM = 0.5,
  LARGE = 0.75,
  FULL = 1,
}

export type FormExecutionComponentProps = TaskExecutionComponentProps<
  TaskForm,
  TaskFormExecution
> & {
  isShortTaskForm?: boolean;
  elements?: Array<FormDefinitionType>;
  executionElements?: Array<FormExecutionType>;
  removeNestedForm?: () => void;
  hideEditButton?: boolean;
  showPrint?: boolean;
  viewSize?: FormExecutionViewSize;
};

const FormExecutionComponent = ({ ...props }: FormExecutionComponentProps) => {
  // Task data determines the rendering method
  const selectedForm =
    props.task.data?.isWizard &&
    props.taskExecution?.state !== TaskExecutionState.Completed ? (
      <WizardFormExecutionComponent {...props} /> // Stepped Format
    ) : (
      <LinearFormExecutionComponent {...props} /> // Linear Format
    );

  return selectedForm;
};

export default FormExecutionComponent;
